import React from "react";
import "./Footer.scss";
import { socialIcons } from "../../../Data";
import { motion } from "framer-motion";
import { FaFacebookSquare, FaWhatsappSquare } from "react-icons/fa";
import { BsGithub, BsLinkedin } from "react-icons/bs";

const Footer = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{
        opacity: 1,
      }}
      transition={{ duration: 1.5 }}
      className="footer"
    >
      <div className="copyright">
        <p>
          Copyright&copy;2022 All rights reserved by <span>Hossain</span>
        </p>
      </div>
      <div className="followMe">
        <h4>Follow Me</h4>
        <div className="stick"></div>
        <div className="social_icons">
          {/* {socialIcons.map((socialIcon, index) => {
            return (
              <div key={index} >
                {socialIcon}
              </div>
            )
          })} */}

          <div>
            <a
              href="https://github.com/HossainRafi"
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub />
            </a>
          </div>
          <div>
            <a
              href="https://www.linkedin.com/in/-rafi"
              target="_blank"
              rel="noreferrer"
            >
              <BsLinkedin />
            </a>
          </div>
          <div>
            <a href="https://web.whatsapp.com" target="_blank" rel="noreferrer">
              <FaWhatsappSquare />
            </a>
          </div>
          <div>
            <a
              href="https://web.facebook.com/rafi.barishal/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookSquare />
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Footer;
